"use strict";
exports.__esModule = true;
exports.getBffUrl = exports.PRODUCTION_URL = exports.STAGING_URL = exports.LOCAL_HOST_URL = void 0;
var lib_environment_1 = require("@doordash/lib-environment");
exports.LOCAL_HOST_URL = 'http://localhost';
exports.STAGING_URL = 'https://risk-bff.doorcrawl.com/challenges';
exports.PRODUCTION_URL = 'https://risk-bff.doordash.com/challenges';
/**
 * Returns the correct URL for the endpoint based on environment.
 * For local development, requests are proxied by webpack dev server.
 */
exports.getBffUrl = function (config) {
    var environment = lib_environment_1.getDSJEnvironment();
    switch (environment) {
        case lib_environment_1.ENVIRONMENTS.PRODUCTION:
            return exports.PRODUCTION_URL;
        case lib_environment_1.ENVIRONMENTS.STAGING:
            return exports.STAGING_URL;
        case lib_environment_1.ENVIRONMENTS.LOCAL:
        default: {
            if (config && config.environment === 'staging') {
                return exports.STAGING_URL;
            }
            if (config && config.environment === 'local') {
                return exports.LOCAL_HOST_URL + ":" + (config.port || '8080') + "/challenges";
            }
            // Some applications (eg identity frontend) do not follow standard
            // @doordash/lib-environment methods to set the environment
            // This is a temporary workaround for that case.
            if (window.Configuration && window.Configuration.redirectUri) {
                if (window.Configuration.redirectUri.includes('doorcrawl.com')) {
                    return exports.STAGING_URL;
                }
            }
            return exports.PRODUCTION_URL;
        }
    }
};
